// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

export type ClientSettingsModelType = {
    activeTaskProfileId: string,
    enableTaskReschedule: boolean,
    defaultTimezoneOffset: string,
    enableCreateTask: boolean,
    enableEntityManagement: boolean,
    enableCustomReports: boolean,
    addTagsToTour: boolean,
    editTourMetadata: boolean,
    allowEditingPayment: boolean,
    allowEditingTaskDetails: boolean,
    allowBulkEditingTaskDetails: boolean,
    allowHomebaseOptions: boolean,
    includeUnallocationReasons: boolean,
    canUpdateChecklists: boolean,
    showCratingInfo: boolean,
    enableAutoSort: boolean,
    enableFileUploadForBatchCreation: boolean,
    enableUnfreeze: boolean,
    enableIncrementalPlan: boolean
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class ClientSettings extends ImmutableModel {
    static fromJS(json: ClientSettingsModelType): ClientSettings {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): ClientSettingsModelType {
        return {
            activeTaskProfileId: this.activeTaskProfileId,
            enableTaskReschedule: this.enableTaskReschedule,
            defaultTimezoneOffset: this.defaultTimezoneOffset,
            enableCreateTask: this.enableCreateTask,
            enableEntityManagement: this.enableEntityManagement,
            enableCustomReports: this.enableCustomReports,
            addTagsToTour: this.addTagsToTour,
            editTourMetadata: this.editTourMetadata,
            allowEditingPayment: this.allowEditingPayment,
            allowEditingTaskDetails: this.allowEditingTaskDetails,
            allowBulkEditingTaskDetails: this.allowBulkEditingTaskDetails,
            allowHomebaseOptions: this.allowHomebaseOptions,
            includeUnallocationReasons: this.includeUnallocationReasons,
            canUpdateChecklists: this.canUpdateChecklists,
            showCratingInfo: this.showCratingInfo,
            enableAutoSort: this.enableAutoSort,
            enableFileUploadForBatchCreation: this
                .enableFileUploadForBatchCreation,
            enableUnfreeze: this.enableUnfreeze,
            enableIncrementalPlan: this.enableIncrementalPlan
        };
    }

    get activeTaskProfileId(): string {
        return this._state.get('activeTaskProfileId');
    }

    setActiveTaskProfileId(activeTaskProfileId: string): this {
        return this.clone(
            this._state.set('activeTaskProfileId', activeTaskProfileId)
        );
    }

    get enableTaskReschedule(): boolean {
        return this._state.get('enableTaskReschedule');
    }

    setEnableTaskReschedule(enableTaskReschedule: boolean): this {
        return this.clone(
            this._state.set('enableTaskReschedule', enableTaskReschedule)
        );
    }

    get defaultTimezoneOffset(): string {
        return this._state.get('defaultTimezoneOffset');
    }

    setDefaultTimezoneOffset(defaultTimezoneOffset: string): this {
        return this.clone(
            this._state.set('defaultTimezoneOffset', defaultTimezoneOffset)
        );
    }

    get enableCreateTask(): boolean {
        return this._state.get('enableCreateTask');
    }

    setEnableCreateTask(enableCreateTask: boolean): this {
        return this.clone(
            this._state.set('enableCreateTask', enableCreateTask)
        );
    }

    get enableEntityManagement(): boolean {
        return this._state.get('enableEntityManagement');
    }

    setEnableEntityManagement(enableEntityManagement: boolean): this {
        return this.clone(
            this._state.set('enableEntityManagement', enableEntityManagement)
        );
    }

    get enableCustomReports(): boolean {
        return this._state.get('enableCustomReports');
    }

    setEnableCustomReports(enableCustomReports: boolean): this {
        return this.clone(
            this._state.set('enableCustomReports', enableCustomReports)
        );
    }

    get addTagsToTour(): boolean {
        return this._state.get('addTagsToTour');
    }

    setAddTagsToTour(addTagsToTour: boolean): this {
        return this.clone(this._state.set('addTagsToTour', addTagsToTour));
    }

    get editTourMetadata(): boolean {
        return this._state.get('editTourMetadata');
    }

    setEditTourMetadata(editTourMetadata: boolean): this {
        return this.clone(
            this._state.set('editTourMetadata', editTourMetadata)
        );
    }

    get allowEditingPayment(): boolean {
        return this._state.get('allowEditingPayment');
    }

    setAllowEditingPayment(allowEditingPayment: boolean): this {
        return this.clone(
            this._state.set('allowEditingPayment', allowEditingPayment)
        );
    }

    get allowEditingTaskDetails(): boolean {
        return this._state.get('allowEditingTaskDetails');
    }

    setAllowEditingTaskDetails(allowEditingTaskDetails: boolean): this {
        return this.clone(
            this._state.set('allowEditingTaskDetails', allowEditingTaskDetails)
        );
    }

    get allowBulkEditingTaskDetails(): boolean {
        return this._state.get('allowBulkEditingTaskDetails');
    }

    setAllowBulkEditingTaskDetails(allowBulkEditingTaskDetails: boolean): this {
        return this.clone(
            this._state.set(
                'allowBulkEditingTaskDetails',
                allowBulkEditingTaskDetails
            )
        );
    }

    get allowHomebaseOptions(): boolean {
        return this._state.get('allowHomebaseOptions');
    }

    setAllowHomebaseOptions(allowHomebaseOptions: boolean): this {
        return this.clone(
            this._state.set('allowHomebaseOptions', allowHomebaseOptions)
        );
    }

    get includeUnallocationReasons(): boolean {
        return this._state.get('includeUnallocationReasons');
    }

    setIncludeUnallocationReasons(includeUnallocationReasons: boolean): this {
        return this.clone(
            this._state.set(
                'includeUnallocationReasons',
                includeUnallocationReasons
            )
        );
    }

    get canUpdateChecklists(): boolean {
        return this._state.get('canUpdateChecklists');
    }

    setCanUpdateChecklists(canUpdateChecklists: boolean): this {
        return this.clone(
            this._state.set('canUpdateChecklists', canUpdateChecklists)
        );
    }

    get showCratingInfo(): boolean {
        return this._state.get('showCratingInfo');
    }

    setShowCratingInfo(showCratingInfo: boolean): this {
        return this.clone(this._state.set('showCratingInfo', showCratingInfo));
    }

    get enableAutoSort(): boolean {
        return this._state.get('enableAutoSort');
    }

    setEnableAutoSort(enableAutoSort: boolean): this {
        return this.clone(this._state.set('enableAutoSort', enableAutoSort));
    }

    get enableFileUploadForBatchCreation(): boolean {
        return this._state.get('enableFileUploadForBatchCreation');
    }

    setEnableFileUploadForBatchCreation(
        enableFileUploadForBatchCreation: boolean
    ): this {
        return this.clone(
            this._state.set(
                'enableFileUploadForBatchCreation',
                enableFileUploadForBatchCreation
            )
        );
    }

    get enableUnfreeze(): boolean {
        return this._state.get('enableUnfreeze');
    }

    setEnableUnfreeze(enableUnfreeze: boolean): this {
        return this.clone(this._state.set('enableUnfreeze', enableUnfreeze));
    }

    get enableIncrementalPlan(): boolean {
        return this._state.get('enableIncrementalPlan');
    }

    setEnableIncrementalPlan(enableIncrementalPlan: boolean): this {
        return this.clone(
            this._state.set('enableIncrementalPlan', enableIncrementalPlan)
        );
    }
}
